module.exports = __webpack_public_path__ + "pf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pf.svg
// module id = 1006
// module chunks = 0